import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">&larr; Volver al inicio</Link>
        <h1 className="legal-title">Pol&iacute;tica de Privacidad</h1>
        <p className="legal-date">
          <em>&Uacute;ltima actualizaci&oacute;n: {new Date().toLocaleDateString('es-ES', { year: 'numeric', month: 'long', day: 'numeric' })}</em>
        </p>

        <section className="legal-section">
          <h2>1. Responsable del tratamiento</h2>
          <p>
            El responsable del tratamiento de los datos personales recabados a trav&eacute;s de este
            sitio web es:
          </p>
          <ul>
            <li><strong>Titular:</strong>Myntar S.L. PENDIENTE NIF</li>
            <li><strong>NIF/CIF:</strong>PENDIENTE</li>
            <li><strong>Domicilio:</strong> Calle Lorenzo Ferreira 26, C&oacute;rdoba, Espa&ntilde;a</li>
            <li><strong>Email:</strong> contact@myntar.tech</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>2. Datos personales que recopilamos</h2>
          <p>
            A trav&eacute;s de este sitio web, Myntar puede recopilar los siguientes datos personales
            proporcionados voluntariamente por el usuario mediante el formulario de contacto:
          </p>
          <ul>
            <li>Nombre completo</li>
            <li>Direcci&oacute;n de correo electr&oacute;nico corporativo</li>
            <li>N&uacute;mero de tel&eacute;fono</li>
            <li>Nombre de la empresa</li>
            <li>Sector de actividad</li>
            <li>Contenido del mensaje/consulta</li>
          </ul>
          <p>
            Adem&aacute;s, de forma autom&aacute;tica, se puede almacenar informaci&oacute;n de
            navegaci&oacute;n como la preferencia de tema visual (claro/oscuro) y la aceptaci&oacute;n
            de cookies, mediante almacenamiento local del navegador (localStorage). Para m&aacute;s
            informaci&oacute;n, consulte nuestra <Link to="/cookies">Pol&iacute;tica de Cookies</Link>.
          </p>
        </section>

        <section className="legal-section">
          <h2>3. Avatar Interactivo - Tratamiento de Datos</h2>
          <p>
            Este sitio web incluye un avatar interactivo impulsado por inteligencia artificial
            que permite a los usuarios interactuar mediante voz o texto. Durante el uso del avatar,
            se recopilan y procesan los siguientes datos:
          </p>

          <h3>3.1 Datos recopilados autom&aacute;ticamente</h3>
          <ul>
            <li><strong>Identificadores de sesi&oacute;n:</strong> Device ID, Session ID (generados aleatoriamente)</li>
            <li><strong>Datos t&eacute;cnicos:</strong> Direcci&oacute;n IP (truncada: &uacute;ltimo octeto eliminado),
            User Agent (navegador y dispositivo)</li>
            <li><strong>Geolocalizaci&oacute;n aproximada:</strong> Pa&iacute;s, ciudad y coordenadas con
            precisi&oacute;n reducida (~1,1 km), derivadas de la IP antes de su truncamiento. No se
            almacenan c&oacute;digo postal ni ruta ASN.</li>
            <li><strong>Audio de voz:</strong> Grabaciones temporales para transcripci&oacute;n (procesamiento transitorio,
            no se almacenan tras transcripci&oacute;n)</li>
            <li><strong>Contenido de conversaci&oacute;n:</strong> Preguntas formuladas y respuestas del avatar</li>
            <li><strong>Metadata de uso:</strong> Fecha/hora de interacci&oacute;n, duraci&oacute;n de sesi&oacute;n</li>
          </ul>

          <h3>3.2 Finalidad del tratamiento</h3>
          <ul>
            <li><strong>Procesamiento de consultas:</strong> Transcribir audio, generar respuestas inteligentes
            y sintetizar voz</li>
            <li><strong>Mejora del servicio:</strong> Analizar patrones de uso para optimizar la experiencia</li>
            <li><strong>Seguridad:</strong> Prevenir abuso y garantizar el correcto funcionamiento</li>
            <li><strong>Demostraci&oacute;n comercial:</strong> Mostrar capacidades del producto a clientes potenciales</li>
          </ul>

          <h3>3.3 Base legal</h3>
          <p>
            <strong>Inter&eacute;s leg&iacute;timo (art. 6.1.f RGPD):</strong> El avatar interactivo opera sin
            registro de usuarios. Los datos se procesan bajo inter&eacute;s leg&iacute;timo para la provisi&oacute;n
            del servicio, prevenci&oacute;n de abuso y analytics agregados. No se identifica a los usuarios finales.
          </p>
          <div className="legal-table-wrapper">
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Dato</th>
                  <th>Base legal</th>
                  <th>Justificaci&oacute;n</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>IP + Device ID</td>
                  <td>Inter&eacute;s leg&iacute;timo (6.1.f)</td>
                  <td>Anti-abuso y control de cuotas</td>
                </tr>
                <tr>
                  <td>Geolocalizaci&oacute;n (pa&iacute;s/ciudad/coordenadas reducidas)</td>
                  <td>Inter&eacute;s leg&iacute;timo (6.1.f)</td>
                  <td>Analytics agregados para el servicio</td>
                </tr>
                <tr>
                  <td>Contenido de conversaci&oacute;n</td>
                  <td>Inter&eacute;s leg&iacute;timo (6.1.f)</td>
                  <td>Provisi&oacute;n del servicio y mejora de calidad</td>
                </tr>
                <tr>
                  <td>Audio de voz (transitorio)</td>
                  <td>Inter&eacute;s leg&iacute;timo (6.1.f)</td>
                  <td>Necesario para transcripci&oacute;n; no se almacena</td>
                </tr>
              </tbody>
            </table>
          </div>

          <h3>3.4 Encargados del tratamiento y transferencias internacionales</h3>
          <p>Para el funcionamiento del avatar, utilizamos los siguientes proveedores externos:</p>

          <div className="legal-table-wrapper">
            <table className="legal-table">
              <thead>
                <tr>
                  <th>Proveedor</th>
                  <th>Funci&oacute;n</th>
                  <th>Datos procesados</th>
                  <th>Ubicaci&oacute;n</th>
                  <th>Garant&iacute;as</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>Lemonfox</strong></td>
                  <td>Transcripci&oacute;n de voz</td>
                  <td>Audio temporal</td>
                  <td>Regi&oacute;n EU</td>
                  <td>DPA</td>
                </tr>
                <tr>
                  <td><strong>OpenAI</strong></td>
                  <td>Generaci&oacute;n de respuestas</td>
                  <td>Texto de conversaci&oacute;n</td>
                  <td>USA</td>
                  <td>DPA + EU-US DPF</td>
                </tr>
                <tr>
                  <td><strong>ElevenLabs</strong></td>
                  <td>S&iacute;ntesis de voz</td>
                  <td>Texto de respuestas</td>
                  <td>USA</td>
                  <td>DPA + SCCs</td>
                </tr>
                <tr>
                  <td><strong>Google Cloud TTS</strong></td>
                  <td>S&iacute;ntesis de voz alternativa</td>
                  <td>Texto de respuestas</td>
                  <td>Regi&oacute;n EU</td>
                  <td>DPA Google Cloud</td>
                </tr>
                <tr>
                  <td><strong>IPLocate</strong></td>
                  <td>Geolocalizaci&oacute;n</td>
                  <td>Direcci&oacute;n IP</td>
                  <td>USA</td>
                  <td>DPA + GDPR</td>
                </tr>
                <tr>
                  <td><strong>Prisma</strong></td>
                  <td>Base de datos</td>
                  <td>Sesiones, conversaciones, analytics</td>
                  <td>Regi&oacute;n EU</td>
                  <td>DPA Prisma</td>
                </tr>
                <tr>
                  <td><strong>Hostinger</strong></td>
                  <td>Hosting servidor (N8N)</td>
                  <td>Datos en tr&aacute;nsito (orquestaci&oacute;n)</td>
                  <td>EU</td>
                  <td>DPA Hostinger</td>
                </tr>
              </tbody>
            </table>
          </div>

          <p>
            <strong>Importante:</strong> Todos los proveedores act&uacute;an como Encargados del Tratamiento bajo
            contrato (DPA - Data Processing Agreement). Las transferencias fuera del EEE se realizan mediante
            Cl&aacute;usulas Contractuales Tipo aprobadas por la Comisi&oacute;n Europea o bajo el marco EU-US Data Privacy Framework.
          </p>

          <h3>3.5 Conservaci&oacute;n de datos</h3>
          <ul>
            <li><strong>Audio de voz:</strong> Procesamiento transitorio en memoria, eliminado inmediatamente
            tras transcripci&oacute;n (no se almacena)</li>
            <li><strong>Sesiones y conversaciones:</strong> 180 d&iacute;as desde la &uacute;ltima
            interacci&oacute;n (eliminaci&oacute;n autom&aacute;tica)</li>
            <li><strong>Analytics agregados:</strong> 365 d&iacute;as (eliminaci&oacute;n autom&aacute;tica
            tras ese periodo)</li>
            <li><strong>Direcci&oacute;n IP:</strong> Truncada (&uacute;ltimo octeto sustituido por .0)
            inmediatamente tras obtener geolocalizaci&oacute;n. Almacenada con la sesi&oacute;n y
            eliminada a los 180 d&iacute;as. No se almacena la direcci&oacute;n IP completa.</li>
          </ul>

          <h3>3.6 Minimizaci&oacute;n de datos</h3>
          <p>
            Myntar aplica el principio de minimizaci&oacute;n de datos:
          </p>
          <ul>
            <li><strong>Truncamiento de IP:</strong> El &uacute;ltimo octeto de la direcci&oacute;n IP se
            sustituye por .0 antes de cualquier almacenamiento (ejemplo: 192.168.1.123 &rarr; 192.168.1.0).
            La IP completa se utiliza &uacute;nicamente de forma transitoria para obtener la
            geolocalizaci&oacute;n y se trunca inmediatamente despu&eacute;s.</li>
            <li><strong>Coordenadas reducidas:</strong> Las coordenadas geogr&aacute;ficas se limitan a
            2 decimales (~1,1 km de precisi&oacute;n), impidiendo la localizaci&oacute;n exacta del usuario.</li>
            <li><strong>Datos no recopilados:</strong> No se almacenan el c&oacute;digo postal ni la
            ruta ASN del usuario.</li>
            <li><strong>Identificadores pseud&oacute;nimos:</strong> Device ID y Session ID son generados
            aleatoriamente y no est&aacute;n vinculados a ninguna identidad real.</li>
            <li><strong>User Agent truncado:</strong> Solo se conserva informaci&oacute;n esencial
            (tipo de dispositivo y navegador).</li>
          </ul>

          <div className="legal-warning">
            <p>
              <strong>Nota sobre audio de voz:</strong> El audio se procesa de forma transitoria en memoria
              exclusivamente para su transcripci&oacute;n a texto y se elimina inmediatamente tras este proceso,
              sin almacenamiento persistente. Myntar NO utiliza el audio para identificaci&oacute;n biom&eacute;trica,
              autenticaci&oacute;n ni perfilado. Al tratarse de un procesamiento transitorio sin almacenamiento
              y sin finalidad identificativa, no constituye tratamiento de datos de categor&iacute;a especial
              bajo el art&iacute;culo 9 del RGPD.
            </p>
          </div>

          <h3>3.7 Usuarios no identificados (Art. 11 RGPD)</h3>
          <p>
            Myntar no identifica a los usuarios finales del avatar interactivo. No se requiere registro
            ni cuenta de usuario para utilizar el servicio. Los identificadores utilizados (Device ID,
            Session ID) son pseud&oacute;nimos generados aleatoriamente y no est&aacute;n vinculados a
            ninguna identidad real.
          </p>
          <p>
            Conforme al art&iacute;culo 11 del RGPD, cuando el responsable del tratamiento no puede
            identificar al interesado, no est&aacute; obligado a mantener, obtener ni tratar informaci&oacute;n
            adicional con el fin de identificarlo. Para ejercer sus derechos de protecci&oacute;n de datos
            en relaci&oacute;n con el avatar, el usuario deber&aacute; proporcionar informaci&oacute;n que
            permita localizar sus datos (por ejemplo, direcci&oacute;n IP y fecha/hora de la interacci&oacute;n).
          </p>

          <h3>3.8 Rol de Myntar como Encargado del Tratamiento</h3>
          <p>
            Cuando el avatar interactivo se integra en sitios web de clientes de Myntar, Myntar act&uacute;a
            como <strong>Encargado del Tratamiento</strong> (Data Processor) conforme al art&iacute;culo 28
            del RGPD. En este caso:
          </p>
          <ul>
            <li>El cliente (titular del sitio web donde se embebe el avatar) es el <strong>Responsable del
            Tratamiento</strong></li>
            <li>Myntar procesa los datos &uacute;nicamente seg&uacute;n las instrucciones del cliente</li>
            <li>La relaci&oacute;n se rige por un contrato de encargado del tratamiento (DPA) entre
            Myntar y el cliente</li>
            <li>El cliente es responsable de informar a sus propios usuarios sobre el uso del avatar</li>
          </ul>
          <p>
            En el sitio web myntar.tech, Myntar act&uacute;a como <strong>Responsable del Tratamiento</strong>.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Finalidad del tratamiento</h2>
          <p>
            Los datos personales proporcionados ser&aacute;n tratados con las siguientes finalidades:
          </p>
          <ul>
            <li><strong>Atender consultas:</strong> Responder a las solicitudes de informaci&oacute;n
            enviadas a trav&eacute;s del formulario de contacto</li>
            <li><strong>Comunicaciones comerciales:</strong> Mantener comunicaci&oacute;n relacionada
            con los servicios de Myntar, &uacute;nicamente si el usuario lo ha solicitado</li>
            <li><strong>Gesti&oacute;n de relaciones:</strong> Gestionar la relaci&oacute;n comercial
            con clientes potenciales y existentes</li>
          </ul>
          <p>
            En ning&uacute;n caso se tomar&aacute;n decisiones automatizadas, incluida la elaboraci&oacute;n
            de perfiles, que produzcan efectos jur&iacute;dicos para el interesado.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. Base legal del tratamiento</h2>
          <p>
            La base legal para el tratamiento de sus datos personales es:
          </p>
          <ul>
            <li><strong>Consentimiento (art. 6.1.a RGPD):</strong> El usuario otorga su consentimiento
            expl&iacute;cito al marcar la casilla de aceptaci&oacute;n en el formulario de contacto.
            Puede retirar su consentimiento en cualquier momento sin que ello afecte a la licitud del
            tratamiento basado en el consentimiento previo a su retirada.</li>
            <li><strong>Inter&eacute;s leg&iacute;timo (art. 6.1.f RGPD):</strong> Para el funcionamiento
            t&eacute;cnico del sitio web (cookies t&eacute;cnicas necesarias), la provisi&oacute;n del
            servicio de avatar interactivo, el control de abuso de cuotas y la generaci&oacute;n de
            analytics agregados. El avatar opera sin registro de usuarios y los datos procesados no
            permiten la identificaci&oacute;n directa del interesado.</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Destinatarios de los datos</h2>
          <p>
            Sus datos personales podr&aacute;n ser comunicados a los siguientes destinatarios:
          </p>
          <ul>
            <li><strong>EmailJS:</strong> Servicio de env&iacute;o de correos electr&oacute;nicos
            utilizado para procesar el formulario de contacto. EmailJS act&uacute;a como encargado
            del tratamiento y procesa los datos &uacute;nicamente para la finalidad de transmitir
            el mensaje al equipo de Myntar.
            (<a href="https://www.emailjs.com/legal/privacy-policy/" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad de EmailJS</a>)</li>
            <li><strong>OpenAI:</strong> Generaci&oacute;n de respuestas del avatar interactivo.
            (<a href="https://openai.com/policies/privacy-policy" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad de OpenAI</a>)</li>
            <li><strong>ElevenLabs:</strong> S&iacute;ntesis de voz del avatar interactivo.
            (<a href="https://elevenlabs.io/privacy" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad de ElevenLabs</a>)</li>
            <li><strong>Google Cloud TTS:</strong> S&iacute;ntesis de voz alternativa del avatar.
            (<a href="https://cloud.google.com/dpa-pso" target="_blank" rel="noopener noreferrer">DPA Google Cloud</a>)</li>
            <li><strong>Lemonfox:</strong> Transcripci&oacute;n de voz del avatar interactivo
            (procesamiento en la Uni&oacute;n Europea).
            (<a href="https://lemonfox.ai/privacy" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de privacidad de Lemonfox</a>)</li>
            <li><strong>IPLocate:</strong> Geolocalizaci&oacute;n aproximada para analytics del avatar.
            (<a href="https://www.iplocate.io/legal/gdpr" target="_blank" rel="noopener noreferrer">GDPR de IPLocate</a>)</li>
            <li><strong>Prisma:</strong> Base de datos para almacenamiento de sesiones, conversaciones
            y analytics del avatar.
            (<a href="https://www.prisma.io/blog/compliance-reqs-complete" target="_blank" rel="noopener noreferrer">Pol&iacute;tica de cumplimiento de Prisma</a>)</li>
            <li><strong>Hostinger:</strong> Proveedor de hosting para el servidor de orquestaci&oacute;n
            (N8N) del avatar.
            (<a href="https://www.hostinger.com/legal/dpa" target="_blank" rel="noopener noreferrer">DPA Hostinger</a>)</li>
          </ul>
          <p>
            No se ceder&aacute;n datos personales a terceros salvo obligaci&oacute;n legal o cuando
            sea estrictamente necesario para la prestaci&oacute;n del servicio solicitado. Todos los
            proveedores mencionados act&uacute;an como Encargados del Tratamiento bajo contrato (DPA).
          </p>
        </section>

        <section className="legal-section">
          <h2>7. Transferencias internacionales</h2>
          <p>
            Los datos personales se procesan principalmente dentro del Espacio Econ&oacute;mico
            Europeo (EEE). En el caso de que alg&uacute;n servicio de terceros (como EmailJS)
            realice transferencias fuera del EEE, estas se realizar&aacute;n con las garant&iacute;as
            adecuadas conforme al RGPD, tales como Cl&aacute;usulas Contractuales Tipo aprobadas por
            la Comisi&oacute;n Europea o decisiones de adecuaci&oacute;n.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Plazo de conservaci&oacute;n</h2>
          <p>
            Los datos personales se conservar&aacute;n durante el tiempo necesario para cumplir con
            la finalidad para la que fueron recabados. En concreto:
          </p>
          <ul>
            <li><strong>Datos de contacto:</strong> Mientras se mantenga la relaci&oacute;n comercial
            o hasta que el usuario solicite su supresi&oacute;n</li>
            <li><strong>Consultas:</strong> Durante un plazo m&aacute;ximo de 12 meses desde la
            &uacute;ltima comunicaci&oacute;n</li>
            <li><strong>Obligaciones legales:</strong> Los datos podr&aacute;n conservarse durante
            los plazos legalmente establecidos para atender posibles responsabilidades</li>
          </ul>
          <p>
            Transcurridos dichos plazos, los datos ser&aacute;n suprimidos o anonimizados de forma
            irreversible.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Derechos del usuario</h2>
          <p>
            De conformidad con el RGPD y la LOPD-GDD, usted tiene derecho a:
          </p>
          <ul>
            <li><strong>Acceso:</strong> Obtener confirmaci&oacute;n de si se est&aacute;n tratando
            sus datos personales y acceder a ellos</li>
            <li><strong>Rectificaci&oacute;n:</strong> Solicitar la correcci&oacute;n de datos
            inexactos o incompletos</li>
            <li><strong>Supresi&oacute;n (derecho al olvido):</strong> Solicitar la eliminaci&oacute;n
            de sus datos cuando ya no sean necesarios para la finalidad que fueron recabados</li>
            <li><strong>Oposici&oacute;n:</strong> Oponerse al tratamiento de sus datos personales
            en determinadas circunstancias</li>
            <li><strong>Limitaci&oacute;n del tratamiento:</strong> Solicitar la limitaci&oacute;n
            del tratamiento en los supuestos previstos legalmente</li>
            <li><strong>Portabilidad:</strong> Recibir sus datos en un formato estructurado, de
            uso com&uacute;n y lectura mec&aacute;nica, y transmitirlos a otro responsable</li>
            <li><strong>Retirada del consentimiento:</strong> Retirar su consentimiento en cualquier
            momento, sin que ello afecte a la licitud del tratamiento previo</li>
          </ul>
          <p>
            Para ejercer cualquiera de estos derechos, puede contactarnos en:
          </p>
          <p>
            <strong>Email:</strong> contact@myntar.tech<br />
            <strong>Asunto:</strong> Protecci&oacute;n de Datos - [Derecho que desea ejercer]
          </p>
          <p>
            Se le podr&aacute; solicitar una copia de su documento de identidad para verificar su
            identidad. Responderemos a su solicitud en el plazo m&aacute;ximo de un mes.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Seguridad</h2>
          <p>
            Myntar implementa medidas t&eacute;cnicas y organizativas apropiadas para proteger sus
            datos personales contra el tratamiento no autorizado o il&iacute;cito y contra su
            p&eacute;rdida, destrucci&oacute;n o da&ntilde;o accidental. Entre estas medidas se incluyen:
          </p>
          <ul>
            <li>Comunicaciones cifradas mediante protocolo HTTPS/TLS</li>
            <li>Control de acceso restringido a los datos personales</li>
            <li>Revisi&oacute;n peri&oacute;dica de las medidas de seguridad</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>11. Cookies</h2>
          <p>
            Este sitio web utiliza cookies y tecnolog&iacute;as de almacenamiento local. Para obtener
            informaci&oacute;n detallada sobre las cookies que utilizamos, su finalidad y c&oacute;mo
            gestionarlas, consulte nuestra <Link to="/cookies">Pol&iacute;tica de Cookies</Link>.
          </p>
        </section>

        <section className="legal-section">
          <h2>12. Modificaciones</h2>
          <p>
            Myntar se reserva el derecho de modificar esta Pol&iacute;tica de Privacidad para
            adaptarla a novedades legislativas, jurisprudenciales o a cambios en nuestras
            pr&aacute;cticas. Le notificaremos cualquier cambio significativo a trav&eacute;s de
            este sitio web. Le recomendamos revisar peri&oacute;dicamente esta p&aacute;gina.
          </p>
        </section>

        <section className="legal-section">
          <h2>13. Reclamaci&oacute;n ante la autoridad de control</h2>
          <p>
            Si considera que el tratamiento de sus datos personales no se ajusta a la normativa
            vigente, tiene derecho a presentar una reclamaci&oacute;n ante la Agencia Espa&ntilde;ola
            de Protecci&oacute;n de Datos (AEPD):
          </p>
          <p>
            <strong>Agencia Espa&ntilde;ola de Protecci&oacute;n de Datos</strong><br />
            C/ Jorge Juan, 6 - 28001 Madrid<br />
            Sitio web: <strong>www.aepd.es</strong>
          </p>
        </section>

        <section className="legal-section">
          <h2>14. Contacto</h2>
          <p>
            Para cualquier consulta relacionada con esta Pol&iacute;tica de Privacidad o con el
            tratamiento de sus datos personales, puede contactarnos en:
          </p>
          <p>
            <strong>Email:</strong> contact@myntar.tech<br />
            <strong>Direcci&oacute;n:</strong> C&oacute;rdoba, Espa&ntilde;a
          </p>
        </section>

        <div className="legal-links-section">
          <p>Ver tambi&eacute;n:</p>
          <ul>
            <li><Link to="/aviso-legal">Aviso Legal</Link></li>
            <li><Link to="/cookies">Pol&iacute;tica de Cookies</Link></li>
            <li><Link to="/terminos">T&eacute;rminos y Condiciones</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
